/** The chapter rail of wide screens (UX-SPEC §3.1): every chapter, the current one marked, each a link to its first paragraph. */
import { useEffect, useRef } from 'preact/hooks';
import type { ViewModel } from '../../shared/viewmodel.ts';
import { RAIL } from '../strings-reader.ts';

export function ChapterRail({
	vm,
	current,
	onPick,
}: { vm: ViewModel; current: number; onPick: (i: number) => void }) {
	const ref = useRef<HTMLElement>(null);
	useEffect(() => {
		if (current < 0) return;
		const el = ref.current?.querySelector('a.is-current') as HTMLElement | null;
		const box = ref.current;
		if (el && box) box.scrollTop = Math.max(0, el.offsetTop - box.clientHeight / 2);
	}, [current]);
	if (vm.chapters.length === 0) return <aside class="rd-rail" aria-hidden="true" />;
	return (
		<aside class="rd-rail" aria-label={RAIL.label} ref={ref}>
			<h2 class="rail-h">{RAIL.title}</h2>
			<ul class="rail-list">
				{vm.chapters.map((c, i) => (
					<li key={c.charStart}>
						<a
							href={`#/read?p=${c.paraStart}`}
							class={i === current ? 'is-current' : undefined}
							aria-current={i === current ? 'true' : undefined}
							onClick={(e) => {
								e.preventDefault();
								onPick(i);
							}}
						>
							<span class="rail-name">{RAIL.chapterLabel(i + 1, c.title)}</span>
						</a>
					</li>
				))}
			</ul>
		</aside>
	);
}
